<div class="content">
  <form
    class="form"
    [formGroup]="technicalConclusionFormGroup()"
  >
    @for (field of technicalConclusionFormFields; track $index) {
      @switch (field.type) {
        @case ('text') {
          <mat-form-field
            appearance="outline"
            class="form-field"
            [class]="getFieldClass()"
          >
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              type="text"
              [formControlName]="field.fieldName"
              (blur)="handleValueChange(field.fieldName)"
            >
          </mat-form-field>
        }
        @case ('textarea') {
          <mat-form-field
            appearance="outline"
            class="form-field"
            [class]="getFieldClass()"
          >
            <mat-label>{{ field.label }}</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="3"
              placeholder="Введите комментарий"
              [formControlName]="field.fieldName"
              (blur)="handleValueChange(field.fieldName)"
            ></textarea>
          </mat-form-field>
        }
      }
    }
  </form>
  @if (!technicalConclusionData().id) {
    <div class="buttons-container">
      @if (noFirstData()) {
        <button
          mat-button
          color="warn"
          type="button"
          (click)="handelDelete()"
        >
          Удалить
        </button>
      }
      <button
        mat-button
        color="primary"
        type="button"
        [disabled]="!technicalConclusionFormGroup().valid"
        (click)="handelCreate()"
      >
        Сохранить
      </button>
    </div>
  }
</div>
